import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Link, useHistory } from "react-router-dom"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import logo from "../../assets/images/logo.png"
import logoLightSvg from "../../assets/images/logo.png"
import { withTranslation } from "react-i18next"
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import axios from "axios"
import { URLS } from "Url"

const Header = props => {
  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  const history = useHistory()

  useEffect(() => {
    const GetStore = async () => {
      try {
        const authUser = localStorage.getItem("authUser")
        if (!authUser) {
          toast.error("Authentication required")
          history.push("/login")
          return
        }

        const data = JSON.parse(authUser)
        const token = data.token

        if (!token) {
          toast.error("Authentication token not found")
          return
        }

        const subscriptionResponse = await axios.post(
          URLS.GetSubscriptionPopUp,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )

        const subscriptionData = subscriptionResponse?.data?.planStatus || false
        if (subscriptionData === false) {
          history.push("/ViewSeller")
        }
      } catch (error) {
        console.error("Error in GetStore:", error)
      }
    }
    GetStore()
  }, [history])

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <div className="d-flex align-items-ceter navigation-buttons" style={{marginLeft:"30px"}}>
              <Link
                to="/dashboard"
                className="btn header-item noti-icon nav-btn"
                title={props.t("Dashboard")}
              >
                <i className="fas fa-home"></i>
                <span className="nav-text d-none d-lg-inline">
                  {props.t("Dashboard")}
                </span>
              </Link>
              <Link
                to="/CustomerList"
                className="btn header-item noti-icon nav-btn"
                title={props.t("Customer List")}
              >
                <i className="fas fa-user-friends"></i>
                <span className="nav-text d-none d-lg-inline">
                  {props.t("Customer List")}
                </span>
              </Link>
              <Link
                to="/AllOrders"
                className="btn header-item noti-icon nav-btn"
                title={props.t("Orders")}
              >
                <i className="bx bxs-receipt"></i>
                <span className="nav-text d-none d-lg-inline">
                  {props.t("Orders")}
                </span>
              </Link>
              <Link
                to="/notifications"
                className="btn header-item noti-icon nav-btn"
                title={props.t("Notifications")}
              >
                <i className="bx bxs-bell"></i>
                <span className="nav-text d-none d-lg-inline">
                  {props.t("Notifications")}
                </span>
              </Link>
            </div>
          </div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
